import './style.less';

export default function(EventClass) {
  'ngInject';
  const vm = this;
  vm.$onChanges = activate;

  function activate() {
    const { event } = vm;
    if (!event) return;

    const isWebinar = event.delivery_method === 2 || event.delivery_method === 11;

    const externalWebinars = EventClass.externalWebinars(event);

    const hasWebinarAttached =
      isWebinar &&
      (externalWebinars.length ||
        event.webinarKey ||
        event.webinarSessionKey ||
        event.zoomMeetingId ||
        event.zoomWebinarId ||
        event.webexSessionKey ||
        (event.url && event.url.length));

    vm.alert = isWebinar && !hasWebinarAttached;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/alerts/controller.js